module.exports = __webpack_public_path__ + "img/Ouyang.c1432658.jpg";